import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

import { and } from './utils/and';

const usePlaybooks = () => {
  return useFlag(FlagType.Playbooks);
};

export const canUsePlaybooks: Permission = and([usePlaybooks]);
